import React, { useMemo } from "react";
import DataTable from "Common/DataTable/DataTable";
import { generateDisplayFields } from "utils/fieldMapper";
import useTableLoanReportConfig from "./useTableLoanReportConfig";
import FormInputFile from "Common/Custom/FormInputFile";

const EmployeeLoansFullView = ({ details = {} }) => {

  const employee = details?.employee || {};
  const loans = details?.loans || [];

  const displayFields = useMemo(
    () =>
      generateDisplayFields([
        { name: "loan_number_display", label: "Loan Number", type: "text" },
        { name: "date_display", label: "Date", type: "text" },
        { name: "total_amount_display", label: "Total Amount", type: "text" },
        { name: "repayment_total_display", label: "Repayment Total", type: "text" },
        { name: "installment_display", label: "Installment", type: "text" },
      ]),
    []
  );

  const formattedLoans = useMemo(
    () =>
      loans.map((loan) => ({
        ...loan,
        loan_number_display: loan.grand_loan_id || "--",
        date_display: loan.date,
        total_amount_display: loan.total_amount,
        repayment_total_display: loan.repayment_total,
        installment_display: loan.installment,
      })),
    [loans]
  );

  const { formattedData, columns } = useTableLoanReportConfig({
    data: formattedLoans,
    page: 1,
    limit: 10,
    canShowAction: true,
    config: {
      entityName: "Loan History",
      idKey: "grand_loan_id",
      displayFields,
      ViewUrl: "view-installment"
    },
    IsEdit: false,
    IsDelete: false,
    isView: true,
    isPrint: false,
  });

  const renderField = (label, value) => (
    <div className="col-lg-4 col-md-6 col-sm-12">
      <div className="p-3 bg-white rounded-4 shadow-sm h-100 border-0 position-relative overflow-hidden">
        <small className="text-secondary text-uppercase fw-semibold mb-1 d-block">
          {label}
        </small>
        <div className="fw-semibold text-dark fs-6">
          {value || <span className="text-muted">--</span>}
        </div>
      </div>
    </div>
  );

  const renderImageField = (label, value) => (
    <FormInputFile field={{ name: label, disabled: true }} handleChange={() => { }} error={null} imagePreview={value} />
  );

  const Section = ({ title, children }) => (
    <div className="mb-5">
      <h5 className="fw-bold text-dark mb-3 border-bottom pb-2 position-relative">
        <span className="pe-2">{title}</span>
      </h5>
      <div className="row g-3">{children}</div>
    </div>
  );

  return (
    <>
      <Section title="Employee Personal Details">
        {renderImageField("Profile Picture", employee.employee_profile)}
        {renderField("Name", employee.employee_name)}
        {renderField("Employee ID", employee.employee_id)}
        {renderField("Position", employee.position || "N/A")}
      </Section>

      <Section title="Loan History">
        <div className="col-12">
          <DataTable
            columns={columns}
            data={formattedData}
            options={{
              loading: false,
              sortableColumns: displayFields.map((field) => field.accessor),
              print: true,
              csv: true,
              pdf: true,
              copy: true,
            }}
            Entries={{ Entries: false }}
            Search={{ search: false }}
            pagination={{ isActive: false }}
          />
        </div>
      </Section>
    </>
  );
};

export default EmployeeLoansFullView;
